export const convertDate = (dateString) => {
  const inputDate = new Date(dateString);

  const options = { year: "numeric", month: "long", day: "numeric" };
  const formattedDate = inputDate.toLocaleDateString("en-US", options);

  const hours = inputDate.getHours();
  const minutes = inputDate.getMinutes();

  const formattedTime = `${hours % 12 || 12}:${
    minutes < 10 ? "0" : ""
  }${minutes} ${hours < 12 ? "am" : "pm"}`;

  const result = `${formattedDate}, ${formattedTime}`;

  return result;
};

export const getDate = (dateString) => {
  console.log(dateString, "dateString");

  const date = new Date(dateString);
  console.log(date);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  const formattedDate = `${month}/${day}/${year}`;
  return formattedDate;
};

export const getGraphDate = (dateString) => {
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};
